// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 941 ? "dimforge" : chunkId) + "." + {"115":"2186fabadd725cdf5d94","237":"514ef2314ab5318a27f2","482":"764ae8c3581fe5f67ae9","657":"670e3afa09e745e1f07e","941":"4c14873f099ca36f2484"}[chunkId] + ".js";
};